import { useEffect } from 'react';
import { signOut } from 'firebase/auth';
import { auth } from 'contexts/FirebaseContext';
import useAuth from 'hooks/useAuth';
import { GuardProps } from 'types/auth';

interface RoleGuardProps extends GuardProps {
  roles: string[];
  errorMessage?: string;
}

export default function RoleGuard({ children, roles, errorMessage }: RoleGuardProps) {
  const { isLoggedIn, user } = useAuth();

  useEffect(() => {
    if (!isLoggedIn) return;
    // A user with no role claim at all must be denied too — treating a missing
    // role as "nothing to check" let freshly created accounts through.
    if (!user?.role || !roles.includes(user.role)) {
      sessionStorage.setItem('accessError', errorMessage || 'Access denied.');
      signOut(auth);
    }
  }, [isLoggedIn, user?.role]);

  return children;
}